// Vue 2 portal for classic dialogs. Escape rail/toolbar stacking contexts while
// retaining the current theme and leaving the legacy mobile experience alone.
const portals = new WeakMap();
export default {
  inserted(el) {
    if (!el.closest('.stockchart-default')) return;
    const anchor = document.createComment('classic dialog');
    el.parentNode.insertBefore(anchor, el);
    const host = document.createElement('div');
    host.className = 'stockchart-default legacy-overlay-host';
    const theme = el.closest('.light-theme, .dark-theme') || document.body;
    const fullscreen = document.fullscreenElement;
    const root = fullscreen && !fullscreen.contains(theme) ? fullscreen : theme;
    root.appendChild(host);
    host.appendChild(el);
    portals.set(el, { host, anchor });
  },
  unbind(el, binding, vnode, oldVnode, isDestroy) {
    const portal = portals.get(el);
    if (!portal) return;
    const { host, anchor } = portal;
    if (anchor.parentNode) {
      // Root-component v-if removal has already detached the vnode. Restoring
      // it here would resurrect stale inputs alongside the reopened dialog.
      if (!isDestroy) anchor.parentNode.insertBefore(el, anchor);
      anchor.parentNode.removeChild(anchor);
    }
    host.remove();
    portals.delete(el);
  }
};
